module.exports.DEFAULT_PLACEMENT = 'DefaultPlacement';
module.exports.DEFAULT_PLACEMENT_NAME = 'Default Placement';
module.exports.DEFAULT_PLACEMENT_LINK = 'https://personatrk.com/serverside/offer/?app_id={app_id}&offer_id=2460596&user_id=';
module.exports.REPORTS_DATE_INFIMUM = '2017-07-01';
module.exports.DEFAULT_NOTIFICATIONS_LIMIT = 5;
module.exports.MIN_PASSWORD_LENGTH = 6;
module.exports.TIMEZONE_OFFSET = -8;
module.exports.IMPRESSION_CSV_KEYS = [
  'campaignId', 'campaignName', 'campaignType', 'campaignEcpm', 'userId',
  'publisherId', 'status', 'appId', 'appName', 'ip', 'clickIp',
  'placementId', 'placementName', 'creativeId', 'creativeImageId', 'creativeUrlDsp',
  'adType', 'trackingUrl', 'platform', 'os', 'country', 'payout', 'publisherPayout',
  'revShare', 'personalyNet', 'virtualCurrencyAmount', 'externalUserId', 'clickDate',
  'leadDate', 'userAgent', 'timestamp',
];
module.exports.CAMPAIGNS_SORTING_CHANGE_FACTOR = 0.8;
module.exports.CAMPAIGNS_SORTINGS_TYPES = {
  ecpm: 'eCPM',
  random: 'random',
};
module.exports.PNG_IMAGE_QUALITY = '20-90';
module.exports.JPEG_IMAGE_QUALITY = '50%';



/** WEBPACK FOOTER **
 ** ../common/constants.js
 **/